export const SELECTORS = {
  PRODUCT_CARD: 'js-above-the-fold-product-card',
  PRODUCT_SWITCHER: 'js-above-the-fold-v3-product-switcher',
  VARIANT_SWITCHER: 'js-above-the-fold-v3-variant-switcher',
  FLAVOR_SWITCHER: 'js-above-the-fold-v3-flavor-switcher',
  FLAVOR_FILTER: 'js-above-the-fold-v3-flavor-filter'
};

export const SECTION_SELECTORS = {
  ABOVE_THE_FOLD: 'js-above-the-fold',
  ABOVE_THE_FOLD_TEMPLATE: 'js-above-the-fold-template',

  KETONE_BOTTLE: 'js-ketone-bottle',
  KETONE_BOTTLE_TEMPLATE: 'js-ketone-bottle-template',

  PRODUCT_PURCHASE_BAR: 'js-product-purchase-bar',
  PRODUCT_PURCHASE_BAR_TEMPLATE: 'js-product-purchase-bar-template'
};
